import doc                        from '@widesk-core/decorators/doc';
import AbstractStandTypologyModel from './AbstractStandTypologyModel';

@doc.urnResource('stand_typology')
export default class StandTypologyModel extends AbstractStandTypologyModel {}
